import React, { useEffect } from "react";
import data from "../data/plasticcomponents";
import InnerCompnents from "../components/innercomponents/innercomponents";

function PlasticComponents() {
  console.log("Fitting", data[0].componentsData);
  
  return (
    <>
      <div className="container-fluid">
        <InnerCompnents componentsData={data[0].componentsData}></InnerCompnents>
      </div>
    </>
  );
}

export default PlasticComponents;
